import request from '@/utils/service'

export function monthCardListApi(data) {
  return request({
    url: '/monthCard/listNew',
    method: 'get',
    params: data
  })
}
export function delMonthCardApi(data) {
  return request({
    url: '/monthCard/delete',
    method: 'post',
    data
  })
}

export function monthCardDetailApi(data) {
  return request({
    url: '/monthCard/detail',
    method: 'get',
    params: data
  })
}

export function addMonthCardApi(data) {
  return request({
    url: '/monthCard/add',
    method: 'post',
    data,
    // 套餐卡包含对象数组，必须按 JSON 提交，避免 qs 转换后后端 ArrayList 反序列化失败。
    notUseQstring: true
  })
}

export function updateMonthCardApi(data) {
  return request({
    url: '/monthCard/update',
    method: 'post',
    data,
    // 套餐卡包含对象数组，必须按 JSON 提交，避免 qs 转换后后端 ArrayList 反序列化失败。
    notUseQstring: true
  })
}

export function updateStatus(data) {
  return request({
    url: '/monthCard/update/status',
    method: 'post',
    data
  })
}

export function giveMonthCard(data) {
  return request({
    url: '/monthCard/giveMonthCard',
    method: 'post',
    data
  })
}
